import Vue from "vue";

import "./styles/quasar.styl";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/ionicons-v4/ionicons-v4.css";
import {
  Quasar,
  QPageSticky,
  QCheckbox,
  Notify,
  QLayout,
  QHeader,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QBtnDropdown,
  QAvatar,
  QBtn,
  QPopupProxy,
  ClosePopup,
  QDate,
  QTabs,
  QTab,
  QRouteTab,
  QSelect,
  QExpansionItem,
  QTable,
  QTh,
  QTr,
  QTd,
  Ripple,
  QScrollArea,
  QDrawer,
  QIcon,
  QFooter,
  QImg,
  QCard,
  QSpinner,
  QCardSection,
  QCardActions,
  QTooltip,
  QForm,
  QInput,
  QDialog,
  Loading,
  QSeparator,
  Dialog,
  QSpace,
  QCarousel,
  QCarouselControl,
  QCarouselSlide,
  QPagination,
  QBanner
} from "quasar";

Vue.use(Quasar, {
  config: {
    loading: {}
  },
  components: {
    QLayout,
    QPageSticky,
    QCheckbox,
    QHeader,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QBtnDropdown,
    QAvatar,
    QBtn,
    QPopupProxy,
    QDate,
    QTabs,
    QTab,
    QRouteTab,
    QSelect,
    QExpansionItem,
    QTable,
    QTh,
    QTr,
    QTd,
    QScrollArea,
    QDrawer,
    QIcon,
    QFooter,
    QImg,
    QSpinner,
    QTooltip,
    QCard,
    QCardSection,
    QCardActions,
    QForm,
    QInput,
    Notify,
    QDialog,
    ClosePopup,
    QSeparator,
    QSpace,
    QCarousel,
    QCarouselControl,
    QCarouselSlide,
    QPagination,
    QBanner
  },
  directives: {
    ClosePopup,
    Ripple
  },
  plugins: {
    Notify,
    Loading,
    Dialog
  }
});
